const genioData = {
  slug: "genio",
  name: "Honda Genio",

  hero: {
    shortDescription:
      "Skutik stylish 110cc dengan desain unik, ringan, dan efisien untuk mobilitas harian",

    variants: [
      {
        key: "vibrant-black",
        label: "CBS",
        fullName: "Honda Genio CBS Vibrant Black",
        startPrice: 20269000,
      },
      {
        key: "vibrant-tritone",
        label: "CBS",
        fullName: "Honda Genio CBS Vibrant Tri-Tone",
        startPrice: 20469000,
      },
      {
        key: "fabulous-green",
        label: "CBS ISS",
        fullName: "Honda Genio CBS ISS Fabulous Matte Green",
        startPrice: 20889000,
      },
    ],

    slides: [
      {
        variantKey: "vibrant-black",
        image: "/assets/motor/produk/genio/Honda-Genio-CBS-Vibrant-Black-1024x1002.webp",
        specs: {
          engine: "109,5 cc, 4 Langkah, SOHC, eSP, Pendingin Udara",
          power: "6,6 kW (9 PS) / 7.500 rpm",
          smartKey: false,
        },
      },
      {
        variantKey: "vibrant-tritone",
        image: "/assets/motor/produk/genio/Honda-Genio-CBS-Vibrant-Tri-Tone-1024x1002.webp",
        specs: {
          engine: "109,5 cc, 4 Langkah, SOHC, eSP, Pendingin Udara",
          power: "6,6 kW (9 PS) / 7.500 rpm",
          smartKey: false,
        },
      },
      {
        variantKey: "fabulous-green",
        image: "/assets/motor/produk/genio/Honda-Genio-CBS-ISS-Fabulous-Matte-Green-1024x1002.webp",
        specs: {
          engine: "109,5 cc, 4 Langkah, SOHC, eSP, Pendingin Udara",
          power: "6,6 kW (9 PS) / 7.500 rpm",
          smartKey: false,
        },
      },
    ],
  },

  description: {
    sections: [
      {
        type: "paragraph",
        text:
          "Honda Genio hadir sebagai skutik bergaya unik dan ekspresif yang dirancang untuk generasi muda dengan mobilitas tinggi di perkotaan.",
      },
      {
        type: "paragraph",
        text:
          "Dibekali mesin 110cc eSP berpendingin udara dengan teknologi PGM-FI, Honda Genio menawarkan performa halus, irit bahan bakar, dan ramah lingkungan.",
      },
      {
        type: "heading",
        text: "Desain Unik dan Stylish",
      },
      {
        type: "paragraph",
        text:
          "Bentuk bodi compact dengan lekukan modern dipadukan rangka eSAF yang ringan untuk kemudahan berkendara dan manuver di lalu lintas padat.",
      },
      {
        type: "heading",
        text: "Nyaman untuk Aktivitas Harian",
      },
      {
        type: "paragraph",
        text:
          "Posisi berkendara ergonomis, dek kaki luas, dan bobot ringan menjadikan Honda Genio nyaman digunakan setiap hari.",
      },
    ],
  },

  specificationsDetail: {
    mesin: [
      [
        "Tipe Mesin",
        "4 Langkah, SOHC, eSP, Pendingin Udara",
      ],
      ["Sistem Suplai Bahan Bakar", "PGM-FI"],
      ["Kapasitas Mesin", "109,5 cc"],
      ["Daya Maksimum", "6,6 kW (9 PS) / 7.500 rpm"],
      ["Torsi Maksimum", "9,3 Nm / 5.500 rpm"],
      ["Transmisi", "Otomatis, V-Matic"],
    ],

    rangka: [
      ["Tipe Rangka", "enhanced Smart Architecture Frame (eSAF)"],
      ["Suspensi Depan", "Teleskopik"],
      ["Suspensi Belakang", "Lengan Ayun"],
      ["Rem Depan", "Cakram"],
      ["Rem Belakang", "Tromol"],
    ],

    dimensi: [
      ["Panjang x Lebar x Tinggi", "1.869 x 692 x 1.061 mm"],
      ["Tinggi Jok", "744 mm"],
      ["Jarak Sumbu Roda", "1.251 mm"],
      ["Berat", "92 kg"],
    ],

    kapasitas: [
      ["Kapasitas Tangki Bahan Bakar", "4,2 Liter"],
      ["Kapasitas Bagasi", "14 Liter"],
    ],

    kelistrikan: [
      ["Sistem Pengapian", "Full Transistorized"],
      ["Tipe Aki", "12V MF"],
      ["Sistem Starter", "Electric & Kick Starter"],
    ],
  },

  fullFeatures: {
    title: "Fitur Unggulan Honda Genio",
    items: [
      {
        title: "Mesin 110cc eSP",
        desc:
          "Mesin irit dan halus dengan performa optimal untuk penggunaan harian.",
      },
      {
        title: "Rangka eSAF",
        desc:
          "Rangka ringan dan kokoh yang meningkatkan kelincahan berkendara.",
      },
      {
        title: "Idling Stop System (ISS)",
        desc:
          "Fitur hemat bahan bakar yang mematikan mesin saat berhenti. *Tersedia pada tipe CBS ISS.",
      },
      {
        title: "Combi Brake System (CBS)",
        desc:
          "Sistem pengereman yang membantu distribusi rem lebih seimbang.",
      },
      {
        title: "Panel Meter Digital",
        desc:
          "Panel meter digital modern dengan informasi lengkap dan mudah dibaca.",
      },
      {
        title: "Full LED Headlight",
        desc:
          "Lampu depan LED dengan visibilitas optimal dan tampilan stylish.",
      },
      {
        title: "Bagasi Luas",
        desc:
          "Bagasi 14 liter untuk menyimpan barang kebutuhan harian.",
      },
    ],
  },
};

export default genioData;
